import Chat from './Svg/Chat';
import styles from 'styles/modules/EmptyBlock.module.scss';
import Typo from './Typo';

const EmptyBlock = ({ title }) => {
    return (
        <>
            <div className={styles.block}>
                <Typo variant={'h3'} className={styles.title}>
                    <Chat />
                    {title}
                </Typo>
            </div>
        </>
    );
};

export default EmptyBlock;
